import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform, Alert } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { adminStyles } from '../styles/adminStyles';
import { spacing } from '../../../theme/useTheme';
import { useNavigation } from '@react-navigation/native';
import { useAdmin } from '../../contexts/AdminContext';

const menuItems = [
  {
    title: 'Dashboard',
    icon: 'grid-outline',
    route: 'AdminPanel'
  },
  {
    title: 'Participants',
    icon: 'people-outline',
    route: 'Participants'
  },
  {
    title: 'Analytics',
    icon: 'analytics-outline',
    route: 'Analytics'
  },
  {
    title: 'User Management',
    icon: 'person-circle-outline',
    route: 'UserManagement'
  },
  {
    title: 'Mentor Management',
    icon: 'school-outline',
    route: 'MentorManagement'
  },
  {
    title: 'Daily Inspirations',
    icon: 'heart-outline',
    route: 'Inspirations'
  },
  {
    title: 'Events',
    icon: 'calendar-outline',
    route: 'EventsManage'
  },
  {
    title: 'Gamification',
    icon: 'trophy-outline',
    route: 'Gamification'
  },
  {
    title: 'Clusters',
    icon: 'map-outline',
    route: 'Clusters'
  },
  {
    title: 'App Version',
    icon: 'phone-portrait-outline',
    route: 'VersionManagement'
  }
];

const AdminSidebar = () => {
  const navigation = useNavigation();
  const { logout } = useAdmin();

  const handleLogout = async () => {
    console.log('Logout button pressed');
    console.log('Navigation object:', navigation);

    if (Platform.OS === 'web') {
      // For web, use window.confirm
      const confirmed = window.confirm('Are you sure you want to logout?');
      if (confirmed) {
        try {
          console.log('Calling logout function');
          await logout();
          console.log('Logout successful, resetting navigation');
          navigation.reset({
            index: 0,
            routes: [{ name: 'AdminLogin' }],
          });
        } catch (error) {
          console.error('Error logging out:', error);
          alert('Failed to logout');
        }
      }
    } else {
      // For mobile, use Alert.alert
      Alert.alert(
        'Logout',
        'Are you sure you want to logout?',
        [
          {
            text: 'Cancel',
            style: 'cancel',
          },
          {
            text: 'Logout',
            style: 'destructive',
            onPress: async () => {
              try {
                console.log('Calling logout function');
                await logout();
                console.log('Logout successful, resetting navigation');
                navigation.reset({
                  index: 0,
                  routes: [{ name: 'AdminLogin' }],
                });
              } catch (error) {
                console.error('Error logging out:', error);
                Alert.alert('Error', 'Failed to logout');
              }
            },
          },
        ]
      );
    }
  };
  return (
    <View style={[styles.container, adminStyles.sidebar]}>
      {/* Logo/Brand Section */}
      <View style={styles.header}>
        <View style={styles.brandContainer}>
          <Text style={styles.brandTitle}>Youth Connect</Text>
        </View>
      </View>

      {/* Navigation Menu */}
      <View style={styles.menu}>
        {menuItems.map((item, index) => (
          <TouchableOpacity
            key={index}
            style={styles.menuItem}
            onPress={() => navigation.navigate(item.route)}
          >
            <View style={styles.menuItemInner}>
              <View style={styles.iconContainer}>
                <Ionicons name={item.icon} size={24} color="#6B7280" />
              </View>
              <Text style={styles.menuText}>{item.title}</Text>
            </View>
          </TouchableOpacity>
        ))}
      </View>

      {/* Footer/User Section */}
      <View style={styles.footer}>
        <TouchableOpacity
          style={styles.logoutButton}
          onPress={handleLogout}
          activeOpacity={0.7}
        >
          <Ionicons name="log-out-outline" size={20} color="#DC2626" />
          <Text style={styles.logoutText}>Logout</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRightWidth: 1,
    borderRightColor: '#E5E7EB',
  },
  header: {
    padding: 24,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    borderRightWidth: 2,
    borderRightColor: '#BFDBFE',
    backgroundColor: '#BFDBFE',
    height: 78,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 16,
  },
  brandContainer: {
    marginBottom: 0,
    marginTop: 0,
  },
  brandTitle: {
    fontSize: 24,
    fontWeight: '600',
    color: '#111827',
    marginTop: 0,
    marginBottom: 2,
    ...(Platform.OS === 'web' ? {
      fontFamily: '',
    } : {}),
  },
  menu: {
    padding: 16,
    flex: 1,
  },
  menuItem: {
    padding: 12,
    borderRadius: 8,
    marginBottom: 4,
    ...(Platform.OS === 'web' ? {
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#F3F4F6',
      },
    } : {}),
  },
  menuItemInner: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    marginRight: 12,
  },
  menuText: {
    fontSize: 14,
    color: '#374151',
    fontWeight: '500',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
    } : {}),
  },
  footer: {
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
    borderRightWidth: 2,
    borderRightColor: '#BFDBFE',
    backgroundColor: '#BFDBFE',
    marginTop: 'auto'
  },
  logoutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    borderRadius: 8,
    ...(Platform.OS === 'web' ? {
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#FEE2E2',
      },
    } : {}),
  },
  logoutText: {
    marginLeft: 12,
    fontSize: 14,
    fontWeight: '500',
    color: '#DC2626',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
    } : {}),
  },
});

export default AdminSidebar;
